import { useAuth } from "@/context/AuthContext";

export function ConnectionNotice() {
  const { connection, retryConnection } = useAuth();
  if (!["offline", "unavailable", "reconnecting"].includes(connection)) return null;
  const messages = {
    offline: "Sem conexão com a internet. Seus campos em edição permanecem nesta tela. Reconectaremos quando a conexão voltar.",
    unavailable: "O servidor ainda não respondeu. Tentaremos novamente em 30 segundos. Seus campos em edição permanecem nesta tela.",
    reconnecting: "Reconectando ao estúdio… O servidor pode estar iniciando. Aguarde sem fechar esta página.",
  };
  return <div role="status" aria-live="polite" data-testid="connection-notice" className="mb-5 flex flex-wrap items-center gap-3 rounded-xl border border-[var(--studio-border)] bg-[var(--studio-panel)] px-4 py-3 text-sm text-[var(--studio-text)]">
    <p className="min-w-0 flex-1 basis-64">{messages[connection]}</p>
    {connection !== "reconnecting" && <button type="button" onClick={retryConnection} className="min-h-11 rounded-lg border border-[var(--studio-border)] px-3 font-semibold hover:bg-[var(--studio-elevated)]">Tentar reconectar</button>}
  </div>;
}
